import * as actions from "../action.constants";

const initialState = {
  notification_list: [],
};

const storeNotifications = (state, action) => {
  return {
    ...state,
    notification_list: action.responsePayload,
  };
};

const handlers = {
  [actions.STORE_NOTIFICATIONS]: storeNotifications,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
